import { render, staticRenderFns } from "./ButtonMessage.vue?vue&type=template&id=59f3bc14&"
import script from "./ButtonMessage.vue?vue&type=script&lang=js&"
export * from "./ButtonMessage.vue?vue&type=script&lang=js&"
import style0 from "./ButtonMessage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports